import React from 'react';
import { BodyText } from '../../atoms';
import { CreditCardAddressWrapper } from './CreditCardAddress.styles';

export type CreditCardAddressProps = {
  /**
   * First address line
   */
  firstLine: string;
  /**
   * Second address line
   */
  secondLine: string;
};

const CreditCardAddress = ({
  firstLine,
  secondLine,
}: CreditCardAddressProps) => {
  return (
    <CreditCardAddressWrapper>
      <BodyText
        variant="body3"
        color="inherit"
        textAlign="right"
        overflow="truncate"
      >
        {firstLine}
      </BodyText>
      <BodyText
        variant="body3"
        color="inherit"
        textAlign="right"
        overflow="truncate"
      >
        {secondLine}
      </BodyText>
    </CreditCardAddressWrapper>
  );
};

export default CreditCardAddress;
